/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsStarHalfFill: {
  name: 'star-half-fill';
  data: string;
} = {
  name: 'star-half-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.437.757a.5.5 0 0 0-.874 0L5.188 5.032l-4.243.471a.5.5 0 0 0-.299.85l3.311 3.311-.947 4.738a.5.5 0 0 0 .733.535L8 12.572l4.257 2.365a.5.5 0 0 0 .733-.535l-.947-4.738 3.31-3.31a.5.5 0 0 0-.298-.85l-4.243-.472L8.437.757ZM8 2.03v9.47a.5.5 0 0 1 .243.063l3.555 1.975-.788-3.94a.5.5 0 0 1 .136-.452l2.765-2.764-3.466-.385a.5.5 0 0 1-.382-.254L8 2.03Z" fill="currentColor"/></svg>`,
};
